import { TYPO } from "styles/Typo";
import { useEffect, useState } from "react";
import { AmountInput, AmountInputHelper, SurveyTitle } from "../util/component";
import { SAA_SURVEY_META } from "utils/constant/STATUS";
import RecommandBox from "../util/survey/RecommandBox";
import { s3UrlSpace, useRecommandData } from "../util/recommand";

const renderRecommand = (category: string, item: any, index: number) => {
  const Image = () => {
    return (
      <img
        src={s3UrlSpace(item?.s3_url || "")}
        alt="recommand"
        width={95}
        height={44}
        className="object-contain aspect-[3/2] w-[90px] "
      />
    );
  };

  switch (category) {
    case "car":
      return (
        <div className="flex justify-between gap-1 items-center" key={index}>
          <p className={`${TYPO.TYPO7_RG} custom-word-break`}>
            <span className="text-blue50">{item["모델"]}</span>{" "}
            <span className="text-gray70">구입 가능</span>
          </p>
          <Image />
        </div>
      );
    case "house":
      return (
        <div className="flex justify-between gap-1 items-center" key={index}>
          <div>
            <p className={`${TYPO.TYPO7_RG}`}>
              <span className="text-gray70">{item?.["시군구"]}</span>{" "}
              <span className="text-gray70">{item?.["평수"]}평</span>
            </p>
            <p className={`${TYPO.TYPO7_RG} custom-word-break`}>
              <span className="text-blue50">{item?.["단지명"]}</span>
              <span className="text-gray70"> 구입 가능</span>
            </p>
          </div>
          <Image />
        </div>
      );
    case "travel":
      return (
        <div className="flex justify-between gap-1 items-center" key={index}>
          <div>
            <p className={`${TYPO.TYPO7_RG}`}>
              <span className="text-blue50">{item?.["국가"]}</span>{" "}
              <span className="text-gray70">{item?.["일수"]} 가능</span>
            </p>
            <p className={`${TYPO.TYPO7_RG} custom-word-break`}>
              <span className="text-gray70">{item?.["컨텐츠"]}</span>
            </p>
          </div>
          <Image />
        </div>
      );
    case "wedding":
      return (
        <div className="flex justify-between gap-1 items-center" key={index}>
          <div>
            <p className={`${TYPO.TYPO7_RG} custom-word-break`}>
              <span className="text-gray70">{item?.["장소"]}에서</span>{" "}
              <span className="text-blue50">{item?.["유형"]}</span>{" "}
              <span className="text-gray70">가능</span>{" "}
            </p>
          </div>
          <Image />
        </div>
      );
    case "retire_lifestyle_amount":
      return (
        <div className="flex justify-between gap-1 items-center" key={index}>
          <div>
            <p className={`${TYPO.TYPO7_RG} custom-word-break`}>
              <span className="text-blue50">{item?.["구간"]}</span>{" "}
            </p>
            <p className={`${TYPO.TYPO7_RG} custom-word-break`}>
              <span className="text-gray70">{item?.["생활양상"]}</span>
            </p>
          </div>
          <Image />
        </div>
      );
    default:
      return <div></div>;
  }
  return "";
};

interface Step3Props {
  value: number | null;
  handleValue: (option: number) => void;
  expenseCategory: string;
}

export default function Step3({
  value,
  handleValue,
  expenseCategory,
}: Step3Props) {
  const { data, isLoading, isError } = useRecommandData(
    expenseCategory,
    value,
    true
  );

  const unitByCategory = {
    car: [1000, 3000, 5000],
    house: [5000, 10000, 50000],
    travel: [50, 100, 300],
    wedding: [500, 1000, 3000],
  };

  // step2에 따른 title 의존
  let title: string =
    `${SAA_SURVEY_META["expense_category"]?.[expenseCategory]?.label}에 얼마를 쓸 건가요?` ||
    "";

  return (
    <div className="bg-background relative w-full ">
      {/* Question Container */}
      <div className="content-stretch flex flex-col items-start justify-start w-full">
        <SurveyTitle text={title} />
        <div className="px-6 py-4 w-full space-y-6">
          <div className=" space-y-[10px]">
            <AmountInput
              value={value}
              setValue={handleValue}
              dataGtmId="saa-consume-survey-target-amount-input"
            />
            <AmountInputHelper
              setValue={handleValue}
              units={
                unitByCategory?.[
                  expenseCategory as keyof typeof unitByCategory
                ] || [100, 500, 1000, 3000]
              }
              value={value || 0}
              dataGtmId="saa-consume-survey-target-amount-input-helper"
            />
          </div>

          {data?.length > 0 && (
            <RecommandBox value={value}>
              {data?.map((item: any, index: number) =>
                renderRecommand(expenseCategory, item, index)
              )}
            </RecommandBox>
          )}
        </div>
      </div>
    </div>
  );
}
